import 'prebid.js/modules/consentManagementTcf.js';
import 'prebid.js/modules/consentManagementUsp.js';
import 'prebid.js/modules/tcfControl.js';

import 'prebid.js/modules/gptPreAuction.js';
import 'prebid.js/modules/dfpAdServerVideo.js';

import 'prebid.js/modules/rtdModule';
import 'prebid.js/modules/permutiveRtdProvider.js';

import 'prebid.js/modules/userId';
import 'prebid.js/modules/euidIdSystem.js';
import 'prebid.js/modules/identityLinkIdSystem.js';
import 'prebid.js/modules/liveIntentIdSystem.js';
import 'prebid.js/modules/uid2IdSystem.js';
import 'prebid.js/modules/pairIdSystem.js';
import 'prebid.js/modules/sharedIdSystem.js';
import 'prebid.js/modules/criteoIdSystem';

import 'prebid.js/modules/unifiedIdSystem.js';

import 'prebid.js/modules/schain.js';
import 'prebid.js/modules/priceFloors.js';

import 'prebid.js/modules/atsAnalyticsAdapter.js';
import 'prebid.js/modules/pubxaiAnalyticsAdapter.js';

import 'prebid.js/modules/connatixBidAdapter.js';

import { getEnv } from '@repo/utils';

if (getEnv().__gpp) {
  import(/* webpackChunkName: "[request]" */ 'prebid.js/modules/consentManagementGpp.js');
}
